import type { TypeFormFieldElement } from '../../../types/form';

import getValidationName from './getValidationName';

// ----------------------------------------------------------------------------

function hasValidationName(field: TypeFormFieldElement): boolean {
    return getValidationName(field).length > 0;
}

// ----------------------------------------------------------------------------

export default hasValidationName;
